{
  "name": "promoflo-ui",
  "version": "1.0.1662",
  "scripts": {
    "ng": "ng",
    "license": "devextreme-license --out src/.devextreme/license-key.ts --force",
    "prestart": "npm run license",
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch && npm run license",
    "prelocal": "npm run license",
    "build": "ng build",
    "watch": "ng build --watch --configuration=development",
    "test": "ng test",
    "laragon": "ng build --watch --configuration=development --output-path=C:/laragon/www/promoflo-ui",
    "home": "ng build --watch --configuration=local --output-path=C:/Users/markr/Laravel/promoflo-ui",
    "local": "ng build --configuration=local"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.6",
    "@angular/common": "^20.0.6",
    "@angular/compiler": "^20.0.6",
    "@angular/core": "^20.0.6",
    "@angular/forms": "^20.0.6",
    "@angular/platform-browser": "^20.0.6",
    "@angular/platform-browser-dynamic": "^20.0.6",
    "@angular/router": "^20.0.6",
    "devextreme": "^26.1.3",
    "devextreme-angular": "^26.1.3",
    "devextreme-schematics": "^1.4.2",
    "dexie": "^3.2.4",
    "exceljs": "^4.3.0",
    "file-saver": "^2.0.5",
    "jspdf": "^2.5.1",
    "ngx-cookie-service": "^20.0.1",
    "ngx-joyride": "^2.5.0",
    "pdfmake": "^0.2.18",
    "posthog-js": "^1.373.4",
    "rxjs": "~7.5.0",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.0.5",
    "@angular/cli": "~20.0.5",
    "@angular/compiler-cli": "^20.0.6",
    "@types/file-saver": "^2.0.5",
    "@types/jasmine": "~4.0.0",
    "@types/pdfmake": "^0.2.5",
    "devextreme-cli": "latest",
    "devextreme-themebuilder": "^26.1.3",
    "jasmine-core": "~4.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "^5.8.3"
  }
}
